<template>
    <div class="d-flex flex-column gap-4">
        <EventEntryDetailsHeading :heading="$t('iFrame.description')" :showIf="!!event.description">
            <SecureHtml v-if="event.description" :html="event.description"/>
        </EventEntryDetailsHeading>

        <EventEntryDetailsHeading :heading="$t('iFrame.priceDetails')" :showIf="!!event.priceDetails">
            <SecureHtml v-if="event.priceDetails" :html="event.priceDetails"/>
        </EventEntryDetailsHeading>

        <EventEntryDetailsHeading :heading="$t('iFrame.services')">
            <EventEntryServices :event="event"/>
        </EventEntryDetailsHeading>

        <EventEntryDetailsHeading :heading="$t('iFrame.details')">
            <EventEntryMoreDetails :event="event"/>
        </EventEntryDetailsHeading>
    </div>
</template>

<script>
import EventEntryMoreDetails
    from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryInfo/EventEntryMoreDetails";
import EventEntryServices
    from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryInfo/EventEntryServices";
import EventEntryDetailsHeading
    from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryDetailsHeading";

export default {
    name: "EventEntryInfo",
    components: {EventEntryMoreDetails, EventEntryServices, EventEntryDetailsHeading},
    props: {
        event: {
            type: Object,
            required: true
        }
    },
}
</script>

<style scoped>

</style>
